import React from 'react'
import PropTypes from 'prop-types'
import { unescape } from 'lodash'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const trim = (s, stringToTrim) => {
  const trimLeading = new RegExp(`^(\\s*${stringToTrim}\\s*)+`)
  const trimTrailing = new RegExp(`(\\s*${stringToTrim}\\s*)+$`)
  return s.replace(trimLeading, '').replace(trimTrailing, '')
}

const RichTextView = ({ content, elmId }) => {
  const formattedContent = (
    <div
      data-elm-id={elmId}
      className={cx('content')}
      dangerouslySetInnerHTML={{
        __html: trim(unescape(content), '<p>&nbsp;</p>'),
      }}
    />
  )
  return content ? formattedContent : null
}

RichTextView.propTypes = {
  content: PropTypes.string.isRequired,
  elmId: PropTypes.string.isRequired,
}

export default RichTextView
